import React from "react";
import { Modal, Typography, Fade, Backdrop } from "@material-ui/core";
import { loadingIndicatorProps } from "./LoadingIndicator.d";
import { useLoadingIndicatorStyles } from "./LoadingIndicatorStyles";
import Spinner from "./Spinner";
const LoadingIndicator: React.FC<loadingIndicatorProps> = (props) => {
	const { open, content } = props;
	const classes = useLoadingIndicatorStyles();
	return (
		<Modal
			open={open}
			className={classes.modal}
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={open}>
				<div className={classes.paper}>
					<Spinner />
					{typeof content === "string" && <Typography>{content}</Typography>}
					{typeof content === "object" && { content }}
				</div>
			</Fade>
		</Modal>
	);
};

export default LoadingIndicator;
